/**
 * "Environments" gadget (Ship): which version runs where, from the deploys Console Next finished and Flow wrote in the
 * project's History (activity `deploy` events: environment, version, outcome, the app's address; hooks/
 * useConsoleDeliveries reports them). The newest per environment, with Open when the deploy gave an address. None yet:
 * "Not deployed with Console Next yet".
 */
import React from 'react';
import PropTypes from 'prop-types';
import { ago } from '../../../utils/blameModel';
import { environmentsOf } from '../../../utils/homeGadgets/ship';
import GadgetCard, { GadgetBody, TabLink } from './GadgetCard';
import { useActivity } from './sources';

const OUTCOME = { success: ['Deployed', 'gd-ok'], failed: ['Failed', 'gd-bad'] };

export default function EnvironmentsGadget({ projectId, onOpenActivity = null }) {
  const { data, error, loading } = useActivity(projectId);
  const envs = environmentsOf(data?.events || []);
  return (
    <GadgetCard links={<TabLink onClick={onOpenActivity}>Activity</TabLink>} testId="envs-gadget" title="Environments">
      <GadgetBody
        data={data}
        empty={envs.length === 0}
        emptyText="Not deployed with Console Next yet."
        error={error}
        errorText="The deploys could not be read just now."
        loading={loading}
        loadingText="Reading the deploys…"
      >
        {() => (
          <ul className="gd-rows">
            {envs.map((env) => {
              const [word, tone] = OUTCOME[env.outcome] || ['Sent', ''];
              return (
                <li className="gd-row" data-testid={`env-${env.environment}`} key={env.environment}>
                  <strong>{env.environment}</strong>
                  <span className="gd-grow">
                    {env.version ? `v${String(env.version).replace(/^v/, '')} · ` : ''}<span className={tone}>{word}</span>
                    <span className="ph-muted ph-small"> · {ago(env.at)}</span>
                  </span>
                  {env.url && <a className="ph-link" href={env.url} rel="noopener noreferrer" target="_blank">Open</a>}
                  {!env.url && env.link && <a className="ph-link" href={env.link} rel="noopener noreferrer" target="_blank">In Console</a>}
                </li>
              );
            })}
          </ul>
        )}
      </GadgetBody>
    </GadgetCard>
  );
}

EnvironmentsGadget.propTypes = { onOpenActivity: PropTypes.func, projectId: PropTypes.string.isRequired };
